import * as types from "../actions/index";

const initialState = {
  loading: false,
  error: null,
  companies: [],
  cursor: null
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_COMPANIES.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_COMPANIES.SUCCESS:
      return {
        ...state,
        loading: false,
        ...payload,
      };
    case types.GET_COMPANIES.FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};
